var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5268 7.25445L12.933 2.6607C12.8721 2.59978 12.7997 2.55147 12.72 2.51854C12.6403 2.4856 12.555 2.46868 12.4688 2.46875H4.59375C4.24565 2.46875 3.91181 2.60703 3.66567 2.85317C3.41953 3.09931 3.28125 3.43315 3.28125 3.78125V18.2188C3.28125 18.5668 3.41953 18.9007 3.66567 19.1468C3.91181 19.393 4.24565 19.5312 4.59375 19.5312H16.4062C16.7543 19.5312 17.0882 19.393 17.3343 19.1468C17.5805 18.9007 17.7188 18.5668 17.7188 18.2188V7.71875C17.7188 7.63254 17.7019 7.54717 17.669 7.4675C17.636 7.38784 17.5877 7.31544 17.5268 7.25445ZM12.4688 7.71875V4.10938L16.0781 7.71875H12.4688Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.5fb2d1094190a02e45325bbd0f9da07d.svg";
export { ForwardRef as ReactComponent };